import { Outlet } from "react-router-dom";

import ChargebeeProvider from "providers/ChargebeeProvider";
import FirstPromoterProvider from "providers/FirstPromoterProvider";
import ZohoProvider from "providers/ZohoProvider";


export default function ThirdPartyServicesLayout() {
  return (
    <>
      { /* support widget */ }
      <ZohoProvider/>

      { /* user related services */ }
      <FirstPromoterProvider/>

      <ChargebeeProvider
        publishableKey={ process.env.REACT_APP_APP_CHARGEBEE_PUBLISHABLE_KEY }
        site={ process.env.REACT_APP_APP_CHARGEBEE_SITE_NAME }
        enableGTMTracking={ true }
        enableGATracking={ true }
      >
        <Outlet/>
      </ChargebeeProvider>
    </>
  );
};
